import { ProfileData } from '../custom-hooks';
import { handleResponse, axiosInstance, API } from './helper';

const getLivePicture = (practiseAdminId: string) =>
  handleResponse(axiosInstance.get(`${API.getLivePicture}?practiseAdminId=${practiseAdminId}`));

const insertLivePic = (payload: ProfileData) =>
  handleResponse(axiosInstance.post(API.insertLivePic, payload));

const updateLivePic = (payload: ProfileData) =>
  handleResponse(axiosInstance.put(API.updateLivePic, payload));

//Practise admin apis
interface OrganisationPayload {
  organisationId: string;
  practiseUserId: string;
}

const getPractiseAdminOrganisationDetailsById = async (payload: OrganisationPayload) =>
  await handleResponse(
    axiosInstance.get(API.getPractiseAdminOrganisationDetailsById, { params: payload })
  );

export type StringOrNull = string | null;
export interface OrganisationDetails {
  practiceCode: string;
  organisationId: StringOrNull;
  organisationName?: StringOrNull;
  contact: StringOrNull;
  address?: StringOrNull;
  alternateContact: StringOrNull;
  websiteUrl: StringOrNull;
  registrationNumber: StringOrNull;
  establishmentYear: StringOrNull;
  logoUrl?: StringOrNull;
  openingTime: StringOrNull;
  closingTime: StringOrNull;
  startDay: StringOrNull;
  endDay: StringOrNull;
  qrCode: StringOrNull;
}

const updateOrgDetails = (payload: OrganisationDetails) =>
  handleResponse(axiosInstance.patch(API.updateOrgDetails, payload));

interface OrganisationLogoUpdate {
  logoUrl: string;
  organisationId: string; // UUID string
}

const updateOrgLogo = (payload: OrganisationLogoUpdate) =>
  handleResponse(axiosInstance.put(API.updateOrgLogo, payload));
export {
  getLivePicture,
  insertLivePic,
  updateLivePic,
  getPractiseAdminOrganisationDetailsById,
  updateOrgDetails,
  updateOrgLogo
};
